module.exports = __webpack_public_path__ + "img/1558964284.141148e4.jpg";